import React, { lazy, Component } from 'react';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { getLearningCampsDetailsByTerm, getinsightcontent, getCampInfo, storeUserAgent, commonAPI } from '../../API/FetchCall';
import SocialMediaButtons from './../SocialShare/socialShare';
import { ReviewCamp } from './../Banner/ReviewComponent';
//import { Similar } from './../Banner/similar';
import { Invite } from './../Banner/invite_people';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import $ from 'jquery';
import { AddWishlist } from '../Banner/addWishlist';
import Rating from 'react-star-rating-component';
import { AdsOne, AdsTwo, ViewTop } from '../../components/others/ads';
//import { Comments } from './../Banner/comments';
import { Helmet } from 'react-helmet';
import { CommentsNew } from './../Banner/commentsnew';
import { SimilarNew } from './../Banner/similarnew';

import { LikeFollow } from './../Banner/like_follownew';
//import { LikeFollow } from './../Banner/like_follow';
import { LikeVideo } from './../Banner/like_video';
import { compose, withProps } from "recompose";
import { BASE_URL, REVIEWDAYS, REVIEWMSG, RATING_GOOGLE, IMG_URL} from '../../constant';
import { ContactInfo } from './../Banner/contact_information';
import Gallery from 'react-grid-gallery';
import { Player } from 'video-react';
import ReactTooltip from "react-tooltip";
import { iplocation, partnerSocialLinks } from '../../common';


import { LikeOnly } from './../Banner/likeV1';
import { FollowOnly } from './../Banner/followV1';

import { LikeOnlyV2 } from './../Banner/likeV2';
import { FollowOnlyV2 } from './../Banner/FollowOnlyV2';

import { AddWishlistNewV1 } from '../Banner/addWishlistNewV1';
import { ReviewTutions } from './../Banner/ReviewComponentV1';

import testorgphoto from "./../../assets/images/kids-play.png";
import actionicon from "./../../assets/icons/schools.png";

import actionicon1 from "./../../assets/icons/v2/compare.png";
import actionicon2 from "./../../assets/icons/v2/review.png";
import actionicon3 from "./../../assets/icons/v2/wishlist.png";
import actionicon4 from "./../../assets/icons/v2/network.png";
import actionicon5 from "./../../assets/icons/v2/phone-call.png";

import '../../../src/assets/css/custom.css';
import '../../../src/assets/css/customV1.css';
import '../../../src/assets/css/mobile.css';

import Comp1 from "./../PageND/Comp1";
import Comp2 from "./../PageND/Comp2";
import Comp3 from "./../PageND/Comp3";
//import Comp4 from "./../PageND/Comp4";
import Comp5 from "./../PageND/Comp5";
import Comp6 from "./../PageND/Comp6";
import Comp7 from "./../PageND/Comp7";
import Comp8 from "./../PageND/Comp8";
import CompContact from "./../PageND/CompContact";
import CompAdmissionProcess from "./../PageND/CompAdmissionProcess";
import CompVideos from "./../PageND/CompVideos";

import { AdHorizontal } from './../Banner/AdHorizontal';
import { AdVertical } from './../Banner/AdVertical';

import { Modal, ModalBody, Button } from 'reactstrap';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import closebtn from '../../../src/assets/icons/close.svg';

import { AddWishlistNewV1inBar } from '../Banner/addWishlistNewV1inBar';
import actionicon6 from "./../../assets/icons/v2/customer-service.png";
import { RetailList } from '../retailer/retailer_list';

import placeholderimage from "../../../src/assets/images/schoolimage.png";
import  placeholderbgimage from "../../../src/assets/images/bg/banner-image-faded.jpg";

import InnerArticles from './inner_articles';

class LearningCampsSinglePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showcp: false,
      isPartner: false,
      firstbrdcrm: '',
      secondbrdcrm: '',
      thirdbrdcrm: '',
      breadcrum2: '',
      breadcrum3: '',
      breadcrumb: '',
      similarList: [],
      contentList: [],
      rating: [],
      review_option: false,
      contact_info: false,
      authe: false,
      average_fees: true,
      error: false,
      partyhall: null,
      socialShare: false,
      showing: false,
      noofreview: 0,
      phone_number: "Click to View/Call",
      readmore: true,
      schoolType: localStorage.getItem('sub_type'),
      sports_type: localStorage.getItem('type'),
      shareurl: window.location.href,
      readmore: true,
      photo_path: [],
      search_link: localStorage.getItem('search_link') ? localStorage.getItem('search_link') : '',
      search_link: localStorage.getItem('search_link') ? localStorage.getItem('search_link') : '',
      comparedataoption1: localStorage.getItem("comparedataoption1") ? localStorage.getItem("comparedataoption1") : 0,
      comparedataoption2: localStorage.getItem("comparedataoption2") ? localStorage.getItem("comparedataoption2") : 0,
      comparedataoption3: localStorage.getItem("comparedataoption3") ? localStorage.getItem("comparedataoption3") : 0,
    };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }


  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight

    const scrolled = winScroll / height
    //console.log(scrolled);
    if (scrolled > 0.108) {
      document.getElementById("floatinmid").style.display = "flex";
    } else {
      document.getElementById("floatinmid").style.display = "none";
    }
  }

  topics = async () => {
    try {
      let req = JSON.stringify({
        role: 4,
        category: 1
      })
      const response = await getinsightcontent(req);
      if (response.status === 1) {
        console.log("Dfgdgfd", response);
        this.setState({ contentList: response.list });
      } else {
        this.setState({ contentList: [] });
      }

    } catch (error) {
      console.log(error);
      this.setState({ error: true });
    }
  };

  changephonenumberState(phone_number) {
    this.setState({ phone_number: phone_number });
  }

  scrollLocation() {
    var hash = "#location";
    $('html, body').animate({
      scrollTop: $(hash).offset().top - 200
    }, 800, function () {

    });
  }

  writereview = (e) => {
    let toastr = '';
    toastr = window.toastr.warning; //warning
    toastr('', REVIEWMSG, {
      positionClass: "toast-bottom-center",
      containerId: "toast-bottom-center"
    });
    setTimeout(function () {
      // window.location.reload();
    }, 1000);
  }

  getSubCategory(subcategory_name) {
    let name = subcategory_name;
    let breadcrums = '';
    this.setState({
      breadcrums: name
    })
    return breadcrums;
  }

  getCategory(id) {
    let breadcrum = '';
    switch (id) {
      case '117':
        breadcrum = 'Below 4 Years';
        break;
      case '118':
        breadcrum = '5 - 7 Years';
        break;
      case '119':
        breadcrum = '8 - 10 Years';
        break;
      case '120':
        breadcrum = '11 - 12 Years';
        break;
      case '172':
        breadcrum = '13 - 15 Years';
        break;
      default:
        breadcrum = 'Below 4 Years';
        break;
    }
    this.setState({
      breadcrumb: breadcrum
    });
    return breadcrum;
  }

  getSubCategory() {

    var paths = window.location.pathname.split("/");

    let breadcrum2 = '';
    this.setState({
      breadcrum2: paths[3],
      breadcrum3: paths[4]
    })

  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    let THIS = this;
    window.$(document).on('click', '.reviewabt', function () {
      THIS.triggerReview();
    })
    this.topics();
    this.getSubCategory();
    var paths = window.location.pathname.split("/");

    var firstbrdcrm = "/" + paths[1] + "/" + paths[2];
    var secondbrdcrm = "/" + paths[1] + "/" + paths[2] + "/" + paths[3];
    var thirdbrdcrm = "/" + paths[1] + "/" + paths[2] + "/" + paths[3] + "/" + paths[4];
    this.setState({
      firstbrdcrm: firstbrdcrm,
      secondbrdcrm: secondbrdcrm,
      thirdbrdcrm: thirdbrdcrm
    });

    //this.getCategory(this.props.match.params.category_id);
    localStorage.setItem('currentpath', window.location.pathname);
    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    let userid, pid = '';
    if (data_auth) {
      let auth_data = JSON.parse(data_auth)
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
      });
      userid = auth_data.user_id;
      pid = auth_data.isPartner;
    } else {
      userid = '';
    }


    let data_auth_feedback = (localStorage.getItem("myData"));
    if (data_auth_feedback) {
      let auth_data = JSON.parse(data_auth_feedback);
      this.setState({
        first_name: auth_data.first_name,
        last_name: auth_data.last_name,
        email_id:auth_data.email_id
      });
    }

    let DetailData = JSON.stringify({
      school_term: this.props.match.params.name,
      user_id: userid,
    });

    getLearningCampsDetailsByTerm(DetailData).then((response) => {
      if (response.status == 1) {
        this.setState({
          partyhall: response.data,
          phone_number_info: response.data.phone_number,
          phone_number: response.data.phone_number,
          last_review_date: response.rating.created_date ? response.rating.created_date : '',
          rating: response.rating,
          noofreview: response.rating.totalReviewers,
          vendor_id: response.data.vendor_id,
          error: false
        });
        if (response.data.vendor_id == pid) {
          this.setState({
            isPartner: true
          })
        }

        //if (response.data.sub_categories == 184) {

        //}

        this.getSubCategory(response.data.category_name);
        this.image_gallery(response.data.photos, response.data.url);
        iplocation(response.data.vendor_id, 8, this.state.user_id, response.data.id);
        var created_date = response.rating.created_date;
        var date1 = new Date();
        var date2 = new Date(created_date);
        var diffDays = date1.getDate() - date2.getDate();
        if (created_date != '') {
          if (diffDays > REVIEWDAYS) {
            this.setState({
              review_option: true,
            });
          } else {
            this.setState({
              review_option: false,
            });
          }
        } else {
          this.setState({
            review_option: true,
          });
        }
      }
    });

    window.addEventListener('scroll', this.listenToScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
    document.removeEventListener("click", this.handleClickOutside);
  }
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      $(".floating-menu").addClass('hidden');
      $(".floating-menu-close-btn").addClass("hidden");
    }
  }
  socialShare() {
    this.setState(prevState => ({
      socialShare: !prevState.socialShare,
    }));
  }

  handle_AverageFees = (e) => {
    this.setState((prevState) => ({
      average_fees: !prevState.average_fees,
    }));
  };

  // getCampInfo = async (id) => {
  //   try {
  //     const res = await getCampInfo(id);
  //     this.setState({
  //       partyhall: res.data,
  //       phone_number_info: res.data.phone_number,
  //       last_review_date :res.rating.created_date ? res.rating.created_date : '',
  //       rating: res.rating,
  //       vendor_id: res.data.vendor_id,
  //       error: false
  //     });
  //     this.SResult(this.props.match.params.category_id);
  //     this.image_gallery(res.data.photos,res.data.url)
  //   } catch (error) {
  //     this.setState({ error: true });
  //   }
  // };

  handleSubmit = (e) => {

    e.preventDefault();
    let toastr = '';
    toastr = window.toastr.success; //warning
    toastr('Message sent to the Provider', {
      positionClass: "toast-bottom-center",
      containerId: "toast-bottom-center"
    });

  };

  image_gallery(photos, url) {

    console.log('photos', photos)

    var photo_string = photos;
    var photo_arr = photo_string.split(",");
    photo_arr = photo_arr.filter(function (el) {
      return el != null && el != '';
    });
    var photo_path = [];

    for (let p = 0; p < photo_arr.length; p++) {
      photo_path.push({
        src: url + photo_arr[p],
        thumbnail: url + photo_arr[p],
        thumbnailWidth: 320,
        thumbnailHeight: 174,
        caption: ""
      })
    }

    console.log('photos', photo_path);
    this.setState({
      photo_path: photo_path
    })
  }

  toggleModalopen = (e) => {
    // alert('setstate')
    this.setState({
      openModalLogin: true
    })
  }
  showContact = (e) => {
    this.setState({
      contact_info: true
    })
  }

  homeLink = () => {
    window.location.replace('/');
  }

  subLink = () => {
    localStorage.setItem('camp_menu', this.state.breadcrums);
    localStorage.setItem('camp_menu_id', this.props.match.params.category_id);
    window.location.replace('/camplinks');
  }

  subLinks = () => {
    localStorage.setItem('camp_menu', this.state.breadcrums);
    localStorage.setItem('camp_menu_id', this.props.match.params.category_id);
    window.location.replace('/camplinks');
  }

  searchLink = () => {
    window.location.replace(this.state.search_link);
    localStorage.setItem('search_link', "");
  }

  addtocompare = () => {

    let id = this.state.partyhall.id;
    let type = 'camp';
    let toastr = '';
    var preschool = localStorage.getItem("camp_compare") ? localStorage.getItem("camp_compare") : '';
    if (preschool != 0) {
      var preschool_compare = JSON.parse(preschool);
    }


    if (preschool != 0) {
      console.log('if')
      let preschool_com_len = preschool_compare.length

      if (preschool_com_len < 5) {
        let preschool_check = preschool_compare.filter(o => o.id == id);

        if (preschool_check != 0) {
          console.log('if if')
          toastr = window.toastr.error; //warning
          toastr('', 'Already in compare list', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });
        } else {
          console.log('if else')
          preschool_compare.push({
            id: id,
            type: type
          });

          localStorage.setItem('camp_compare', JSON.stringify(preschool_compare));

          toastr = window.toastr.success;
          toastr('', 'Added To compare list', {
            positionClass: "toast-bottom-center",
            containerId: "toast-bottom-center"
          });

        }
      } else {
        toastr = window.toastr.error; //warning
        toastr('', 'Only allow 5 Learning Camps to compare', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"
        });
      }
    } else {
      console.log('else')
      let preschool_arr = [];
      preschool_arr.push({
        id: id,
        type: type
      });

      localStorage.setItem('camp_compare', JSON.stringify(preschool_arr));

      toastr = window.toastr.success;
      toastr('', 'Added To compare list', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });

    }

  }

  handleclick = (e) => {

    $(".floating-menu").toggleClass("hidden");
    $(".floating-menu-close-btn").toggleClass("hidden");

  }
  handleclickhide = (e) => {

    $(".floating-menu").addClass('hidden');
    $(".floating-menu-close-btn").addClass("hidden");
  }

  handleclose = (e) => {
    $(".floating-menu").addClass('hidden');
    $(".floating-menu-close-btn").addClass("hidden");
  }


  handleCloseCp = (e) => {
    this.setState({ showcp: false });
  }



  hideComponent(name) {
    //console.log(name);  
    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    $(".btnblock").removeClass('active');
    switch (name) {
      case "showAbout":
        const about_section = document.getElementById('about_section');
        about_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#aboutlink").addClass('active');
        break;
      case "showKeyInfo":
        const keyinfo_section = document.getElementById('keyinfo_section');
        keyinfo_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#keyinfolink").addClass('active');
        break;
      case "showLocation":
        const ratings_section = document.getElementById('location_section');
        ratings_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#locationlink").addClass('active');
        break;
      case "showContact":
        const contactinfo_section = document.getElementById('contactinfo_section');
        contactinfo_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#contactlink").addClass('active');
        break;
      case "showGallery":
        const gallery_section = document.getElementById('gallery_section');
        gallery_section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
        $("#gallerylink").addClass('active');
        break;

      default:
        null;
    }
  }

  readmore = (e) => {
    $(".b5caz").removeClass("less");
    $(".b5caz").addClass("more");
    this.setState({
      readmore: false
    })
  }
  readless = (e) => {
    $(".b5caz").removeClass("more");
    $(".b5caz").addClass("less");
    this.setState({
      readmore: true
    })
  }
  adlink(type, link) {
    let req = JSON.stringify({
      category_id: 8,
      page_id: this.props.match.params.id,
      customer_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      is_admission: type == 1 && true,
      is_website: type == 2 && true,
      url: 'clickcount'
    });
    commonAPI(req).then(res => {
      console.log('res', res);
    });
    window.open(
      link,
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  triggerReview = () => {
    document.getElementById("review-btn").click();
  }
  render() {
    function addReadMoreSchool() {
      //This limit you can set after how much characters you want to show Read More.
      var carLmt = 600;
      // Text to show when text is collapsed
      var readMoreTxt = " ... Read More";
      // Text to show when text is expanded
      var readLessTxt = " Read Less";


      //Traverse all selectors with this class and manupulate HTML part to show Read More
      $(".addReadMoreSchool").each(function () {
        if ($(this).find(".firstSec").length)
          return;

        var allstr = $(this).text();
        if (allstr.length > carLmt) {
          var firstSet = allstr.substring(0, carLmt);
          var secdHalf = allstr.substring(carLmt, allstr.length);
          var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
          $(this).html(strtoadd);
        }

      });
      //Read More and Read Less Click Event binding
      $(document).on("click", ".readMore,.readLess", function () {
        $(this).closest(".addReadMoreSchool").toggleClass("showlesscontent showmorecontent");
      });
    }
    $(function () {
      //Calling function after Page Load
      addReadMoreSchool();
    });

    const { partyhall, error } = this.state;
    const { showcp } = this.state;

    if (partyhall === null) {
      return (
        <React.Fragment>
          <div class="overlay-custom"></div>
          <Header />
          <div class='spinner' role='status'>
            <span class='sr-only'>Loading...</span>
          </div>
          <div className='preloadDiv'></div>
          <Footer />
        </React.Fragment>
      );
    }

    const {
      type_name,
      about_camp,
      camp_name,
      contact_person,
      email_id,
      event_fee,
      class_fee,
      class_fee_type,
      facebook,
      images,
      invities,
      photos,
      registeration,
      registration_no,
      twitter,
      vender,
      website,
      when,
      where,
      student_ratio,
      latitude,
      longitude, phone_number, rating, other_rating,
      has_trail,
      trail_desc,
      video_path,
      url,
      user_type,
      noclass
    } = partyhall;
    let type = '';
    switch (invities) {
      case "0_to_3":
        type = '0 to 3 Yrs'; break;
      case "4_to_8":
        type = '4 to 8 Yrs'; break;
      case "9_to_12":
        type = '9 to 12 Yrs'; break;
      case "13_to_15":
        type = '13 to 15 Yrs'; break;
      default:
        type = invities;
    }
    let about_text = about_camp;
    if (about_camp.includes('We are committed to updating all relevant information')) {
      about_text = `
      We are committed to updating all relevant information needed to help you make 
      a wise and efficient decision and are actively working with our 
      <a href='https://partner.bewise.in/individual' target='_blank'>individual</a> and 
      <a href='https://partner.bewise.in/institution' target='_blank'>institutional</a> partners 
      to update their details on our portal! Join us in that endeavour 
      by co-creating value – Have you engaged with this institute as a parent of a student, 
      or as a potential consumer? Do you know what they specialize in? Share your 
      <a href='javascript:;' class='reviewabt'>review</a> 
      and comments on the platform, or <a href='javascript:;' class='contactusabt' data-toggle="modal" 
      data-target="#postQueryModal">contact us</a>, to help the larger community! Stay tuned for more
      `;
    }
    const { showing } = this.state;
    let socialShare = this.state.socialShare;

    let retailData = {
      category_id: 8,
      subcategory_name: this.props.match.params.subcategory,
      location: this.props.match.params.city,
    }
    let review = {
      review_id: this.state.partyhall.id,
      user_id: this.state.user_id,
      keyword: 8,
      last_review_date: this.state.last_review_date,
      vendor_id: this.state.vendor_id,
      partner_type: user_type,
    }
    let commentParm = {
      category_id: 8,
      category: this.props.match.params.category_id,
      id: this.props.match.params.id,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
    }

    let wishlistParm = {
      category_id: 8,
      category: this.props.match.params.category_id,
      id: this.props.match.params.id,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      full_url: window.location.href
    }

    let newcommentsParm = {
      category_id: 8,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.name,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      whichtable: 'learningcamps'

    }


    let likefollowParm = {
      category_id: 8,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.name,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      whichtable: 'learningcamps'
    }


    let similar = {
      module: 8,
      ref_name: this.props.match.params.name,
      category_name: this.props.match.params.subcategory,
      route: this.props.match.params.city + "/learning-camps/" + this.props.match.params.subcategory,
      whichtable: 'learningcamps'
    }


    let videoParm = {
      is_like: 0,
      type: 3,
      user_id: this.state.user_id,
      ref_id: this.state.partyhall.id,
      vendor_id: this.state.vendor_id,
      main_category: 8,
      category: this.props.match.params.subcategory,
    }
    let phone_number_info = {
      email_id: email_id,
      phone_number_info: this.state.phone_number_info,
      category_id: 8,
      category: this.props.match.params.subcategory,
      id: this.state.partyhall.id,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      org_name: camp_name
    }
    let smilar = {
      module: 8,
      ref_id: this.props.match.params.id,
      category: this.props.match.params.category_id,
    }
    let invitedata = {
      url: window.location.href,
      share_name: camp_name,
      vendor_id: this.state.vendor_id,
      module: 8,
      category: this.props.match.params.category_id,
      category_name: 'Learning Camp'
    }

    let likeParm = {
      category_id: 8,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.name,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      whichtable: 'learningcamps',
      scope: 'like'
    }

    let followParm = {
      category_id: 8,
      category_name: this.props.match.params.subcategory,
      ref_name: this.props.match.params.name,
      user_id: this.state.user_id,
      vendor_id: this.state.vendor_id,
      whichtable: 'learningcamps',
      scope: 'follow'
    }

    const keyinfosettings = {
      dots: false,
      infinite: false,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    let galleryinfo = this.state.photo_path;

    const gallerysettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    let keyinfo = <div className='keyinfosec'>
      <div class="desktoponly">
        <div className='row'>
          <div className='col-4'>
            <div className='ki_title'>Type </div>
            <div className='ki_ans'>{type_name}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Contact Person</div>
            <div className='ki_ans'>{contact_person}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Email Id</div>
            <div className='ki_ans'>{email_id}</div>
          </div>
        </div>
        <div className='row n8frx'>
          <div className='col-4'>
            <div className='ki_title'>Age group</div>
            <div className='ki_ans'>{type}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Student Ratio</div>
            <div className='ki_ans'>{student_ratio}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Avg Fee</div>
            <div className='ki_ans'>{'₹ ' + Number(class_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}{(class_fee_type == '' || class_fee_type == '0') &&
              (' NA')
            }
              {(class_fee_type == '2') &&
                (' / Participant')
              }
              {(class_fee_type == '1') &&
                (` / Class`)
              }</div>
          </div>
        </div>
        <div className='row n8frx'>
          <div className='col-4'>
            <div className='ki_title'>No of Class /Month</div>
            <div className='ki_ans'> {noclass && noclass != 0 ? noclass : 'NA'}</div>
          </div>
          <div className='col-4'>
            <div className='ki_title'>Free Trial Class </div>
            <div className='ki_ans'>
              {(has_trail == undefined || has_trail == '0') &&
                ('NA')
              }
              {(has_trail == '2') &&
                ('No')
              }
              {(has_trail == '1') &&
                (`Yes, ${trail_desc}`)
              }
            </div>
          </div>

        </div>

      </div>
      <div class="mobileonly">
        <Slider {...keyinfosettings} >

          <div className='cardblock'>
            <div class="stacklist">
              <div className='ki_title'>Type </div>
              <div className='ki_ans'>{type_name}</div>
            </div>
            <div class="stacklist">
              <div className='ki_title'>Contact Person</div>
              <div className='ki_ans'>{contact_person}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Email Id</div>
              <div className='ki_ans'>{email_id}</div>
            </div>
          </div>

          <div className='cardblock'>
            <div class="stacklist">
              <div className='ki_title'>Age group</div>
              <div className='ki_ans'>{type}</div>
            </div>
            <div class="stacklist">
              <div className='ki_title'>Student Ratio</div>
              <div className='ki_ans'>{student_ratio}</div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Avg Fee</div>
              <div className='ki_ans'>{'₹ ' + Number(class_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}{(class_fee_type == '' || class_fee_type == '0') &&
                (' NA')
              }
                {(class_fee_type == '2') &&
                  (' / Participant')
                }
                {(class_fee_type == '1') &&
                  (` / Class`)
                }</div>
            </div>

          </div>


          <div className='cardblock'>

            <div class="stacklist">
              <div className='ki_title'>No of Class /Month</div>
              <div className='ki_ans'>
                {noclass && noclass != 0 ? noclass : 'NA'}
              </div>
            </div>

            <div class="stacklist">
              <div className='ki_title'>Free Trial Class</div>
              <div className='ki_ans'>{(has_trail == undefined || has_trail == '0') &&
                ('NA')
              }
                {(has_trail == '2') &&
                  ('No')
                }
                {(has_trail == '1') &&
                  (`Yes, ${trail_desc}`)
                }</div>
            </div>



          </div>

        </Slider>
      </div>
    </div>;

const orgphoto = (partyhall.images!='')? IMG_URL+partyhall.images:placeholderimage;
var buildingphotos = (partyhall.photos!='') ? partyhall.photos.split(",") :[];
const propertyimageasBg = (partyhall.photos!='')? IMG_URL+buildingphotos[0]:placeholderbgimage;

    return (
      <React.Fragment>
        
        <div className="body-custom-class">
          <Header login={this.state.openModalLogin} />

          <div className='container'>
            <div className='row display-flex-center main_detail_header' id="main_detail_header">
              <div className='col-lg-12 col-md-12 col-xs-12 nopadleft nopadright'>
              <div className='detailBanner' style={{backgroundImage:`linear-gradient(45deg, rgb(71 66 245 / 91%), rgb(186 195 203 / 75%)), url(`+propertyimageasBg+`)`}}>
                  <div className="row display-flex-center">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                      <div class="breadcrumbsv2 new-breadcrumbs-v2">
                        <div class="bcitem"><span>Home</span></div>
                        <div class="bcitem_div"></div>
                        <div class="bcitem"><span>Learning Camps</span></div>
                        <div class="bcitem_div"></div>
                        <div class="bcitem">
                          <a
                            href={`/${this.props.match.params.city}/learning-camps/${this.props.match.params.subcategory}`}>
                            {this.state.breadcrum2}
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                      <div className="ver_detail_block desktoponly">

                      <div className="row">
                          <div className="displayflex">
                            <div class="per40image">
                              <img src={testorgphoto} className="orgphotofull" />
                            </div>
                            <div class="per50">

                            <div class="displayflex"> 
                                <div class="orginfo">
                                    <div className="org_name">{camp_name} &nbsp; {partyhall.stamp_img && <img className='stamp-view' src={partyhall.url + partyhall.stamp_img} />}</div>
                                    <div className="org_address">{where}</div>
                                </div>
                                <div class="orgfollows">
                                {(this.state.authe === false) ?
                                    <div class="likes" onClick={this.toggleModalopen}>
                                    <LikeOnlyV2 paramId={likeParm} />
                                    </div>
                                    : 
                                    <div class="likes">
                                    <LikeOnlyV2 paramId={likeParm} />
                                    </div>
                                }

                                    {(this.state.authe === false) ?
                                    <div class="follows" onClick={this.toggleModalopen}>
                                        
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div> :
                                     <div class="follows">
                                         
                                        <FollowOnlyV2 paramId={followParm} />
                                    </div>
                                    }
                                </div>
                              </div>  
                              <div class="row paddingleft20">

                                <div class="col-12">
                                    <div className="bewiseratingsv1">
                                        <div>Bewise Ratings: </div>
                                        <div>
                                        <Rating className="col-5 col-md-4 col-5 col-md-4"
                                                               name={"bewiserating"}
                                                               editing={false}
                                                               value={this.state.totalReview}
                                                                
                                                                
                                        />
                                </div></div></div>

                                <div class="col-12">
                                    <div className="googleratingsv1">
                                        <div>Google Ratings:</div>
                                        <div>
                                        <Rating className="col-5 col-md-4 col-5 col-md-4"
                                                               name={"googlerating"}
                                                               editing={false}
                                                               value={partyhall.other_rating}                                                                 
                                        />
                                        </div></div></div>

                              </div>

                              <div class="row">
                              <div class="actionicons pull-right">
                              <div class="alignicons">
                                <div class="actionbutv2" onClick={this.addtocompare} title="Compare">
                                  Compare
                                </div>
                              </div>

                              {(this.state.authe === false) ? (

                                <div class="alignicons">
                                  <div id='review-btn' class="actionbutv2" onClick={this.toggleModalopen} title="Write Review">
                                      Write Review
                                  </div>
                                  
                                </div>
                              )
                                :

                                <ReviewTutions data={review} />
                              }
                              <div class="alignicons">
                                  <div className="actionbutv2" title="Share" id="socialShareIconsNew">
                                    Share
                                  </div>
                                   
                              </div>
                              <div className="main-social-icons">
                                <UncontrolledPopover trigger="legacy" placement="bottom" target="socialShareIconsNew">
                                  <PopoverBody>
                                    <div className="share-icon-social">
                                      <SocialMediaButtons url={this.state.shareurl} text={partyhall.schoolName} />
                                    </div>
                                  </PopoverBody>
                                </UncontrolledPopover>
                              </div>
                              <AddWishlistNewV1 paramId={wishlistParm} />
                              <div class="alignicons">
                                <div className="actionbutv2" onClick={() => this.setState({ showcp: true })} title="Mail To The Camp">
                                Enquire now
                                </div>
                                 
                              </div>
                            </div>
                              </div>

                            </div>
                          </div>
                         </div>
                         

                      </div>
                      <div className="ver_detail_block mobileonly">

                        <div className="row">
                          <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center no-padding">
                            <div class="per30">
                              <img src={testorgphoto} className="orgphoto" />
                            </div>
                            <div class="per70">
                              <div className="org_name">{camp_name} &nbsp; {partyhall.stamp_img && <img className='stamp-view' src={partyhall.url + partyhall.stamp_img} />}</div>
                              <div className="org_address">{where}</div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                             <div class="container-fluid">
                              <div class="row">
                                <div class="col-xs-6"><div className="bewiseratings">Bewise Ratings: <span>{this.state.rating.totalReview !== 'NaN' ? this.state.rating.totalReview : '0.0'}</span></div></div>

                                <div class="col-xs-6">

                                  {(this.state.authe === false) ?
                                    <span onClick={this.toggleModalopen}>
                                      <FollowOnly paramId={followParm} />
                                    </span>
                                    :
                                    <FollowOnly paramId={followParm} />
                                  }

                                </div>

                                <div class="col-xs-6"><div className="googleratings">Google Ratings: <span>{other_rating}</span></div></div>

                                <div class="col-xs-6">

                                  {(this.state.authe === false) ?
                                    <span onClick={this.toggleModalopen}>
                                      <LikeOnly paramId={likeParm} />
                                    </span>
                                    :
                                    <LikeOnly paramId={likeParm} />
                                  }

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="row desktoponly" id="floatinmid">

              <div className="col-lg-6 col-sm-12 col-md-6 col-xs-6 text-center">

                <div class="breadcrumbsv3">
                  <div class="bcitem"><a href={'/'}>Home</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem"><a href={this.state.firstbrdcrm}>Learning Camps</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem"><a href={this.state.secondbrdcrm}>{this.state.breadcrum2}</a></div>
                  <div class="bcitem_divv3"></div>
                  <div class="bcitem itemhighlighted">{camp_name}</div>
                </div>

              </div>
              <div className="col-lg-6 col-sm-12 col-md-6 col-xs-6 text-center">

                <div className="ver_action_block_in_bar desktoponly">
                  <div class="row display-flex-center">
                    <div class="col-2 text-center actionbtn" title="Compare" onClick={this.addtocompare} onclick="ga(‘send’, ‘event’, 'schools', Get Direction, ‘label’, value, {‘NonInteraction’: 1});">
                      <div className="icondiv"><img src={actionicon1} /></div>

                    </div>


                    <div class="col-2 text-center actionbtn" title="Write Review" onClick={() => this.writereview()}>
                      <div className="icondiv"><img src={actionicon2} /></div>

                    </div>

                    <div class="col-2 text-center actionbtn" title="Share">
                      <div className="icondiv"><img src={actionicon4} id="socialShareIconsMob" /></div>
                      <div className="main-social-icons">
                        <UncontrolledPopover trigger="legacy" placement="bottom" target="socialShareIconsMob">
                          <PopoverBody>
                            <div className="share-icon-social">
                              <SocialMediaButtons url={this.state.shareurl} />
                            </div>
                          </PopoverBody>
                        </UncontrolledPopover>
                      </div>
                    </div>

                    <AddWishlistNewV1inBar paramId={wishlistParm} />

                    <div class="col-2  text-center actionbtn " title="Contact Service Provider" alt="Contact Service Provider" onClick={() => this.setState({ showcp: true })} onclick="ga(‘send’, ‘event’, 'schools', Get Direction, ‘label’, value, {‘NonInteraction’: 1});">
                      <div className="icondiv"><img src={actionicon6} /></div>

                    </div>


                  </div>

                </div>

              </div>

            </div>


            <div className="row">

              <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center">
                <div class="oneAd"><AdHorizontal /></div>
              </div>

            </div>

            <div className="row main_info">

              <div className="col-lg-2 col-sm-12 col-md-12 col-xs-12 text-center infoBlock">

                <div class="onDemandInfoLinks">

                  <div className="btnblock active" id="aboutlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showAbout")}>
                      About </div>
                  </div>
                  <div className="btnblock" id="keyinfolink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showKeyInfo")}>
                      Key Information </div>
                  </div>
               
                <div className="btnblock" id="reviewlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showReview")}>
                      Reviews/ Comments </div>
                  </div>

                  <div className="btnblock" id="subjectlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showSubject")}>
                      Location </div>
                  </div>

                  <div className="btnblock" id="gallerylink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showGallery")}>
                      Gallery </div>
                  </div>

                  <div className="btnblock" id="contactlink">
                    <div className="normallinkbtn" onClick={() => this.hideComponent("showContact")}>
                      Contact Info </div>
                  </div>

                </div>

              </div>

              <div className="col-lg-8 col-sm-12 col-md-12 col-xs-12 text-center">

                <div class="onDemandInfo" id="onDemandInfo">
                  <Comp1 paraminfo={about_text} />
                  <br />
                  <Comp2 paraminfo={keyinfo} />
                  <br/>
                  <div id="review_section">
                    <h3 className="review_head" onClick={this.triggerReview}>Review
                      {this.state.authe && this.state.noofreview > 0 && (` (${this.state.noofreview})`)}
                      <div style={{ float: 'right' }}>
                        <small className='pointer' >
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </small>
                      </div>
                    </h3>
                    <div class="reviewinfo">
                      {(this.state.authe === false) ?
                        <div className="col-md-12" onClick={this.toggleModalopen}>
                          <div class="detailBox">
                            <div className="form-comments">
                              <p>Click here to view Comments!...</p>
                            </div>
                          </div>
                        </div>
                        :
                        <div className="col-md-12">
                          <CommentsNew paramId={newcommentsParm} />
                        </div>
                      }
                    </div>
                  </div><br />
                  <br/>
                  <div id="location_section">
                    <h3>Location</h3>
                    <div class="subjectinfo subjectscrollpad">{where}</div>
                  </div>
                  <br />
                  <div id="gallery_section"><h3>Gallery</h3>
                    {galleryinfo.length == 0 &&
                      <div>No Gallery</div>
                    }
                    {galleryinfo.length > 0 &&
                      <Slider {...gallerysettings}>
                        {
                          galleryinfo && galleryinfo.map((d) => {
                            return (

                              <div className="text-center"><img src={d.src} width="200px" /></div>
                            )

                          })
                        }
                      </Slider>
                    }
                  </div>

                  <br />
                  <CompContact phone={this.state.phone_number} email={email_id} />
                  <br />
                  <RetailList retail={retailData} />
                </div>

              </div>


              <div className="col-lg-2 col-sm-12 col-md-12 col-xs-12 text-center nopadleftright">

                <div class="rightSideBar">

                  <div class="rsb latestarticles">

                    <h3>Articles</h3>
                    <div class="artcileslist desktoponly">

                      <ul className='related-topics'>
                        {this.state.contentList.map((content, i) => {
                          let THIS = this;
                          let cont = (content.title.length > 40) ? content.title.substring(0, 40) + '... ' : content.title;
                          let bannerimg = (content.banner_image) ? content.banner_image : 'https://api.bewise.in/uploads/insights/insight_bannerbraznx.png';
                          
                          return (
                            <React.Fragment>
                              <div className='row insight-list-page bloglistSp'>
                                <div className='col-md-3'>
                                  <img src={ bannerimg} className="insight-home-custome-img" alt='Banner Image' />
                                  
                                </div>
                                <div className='col-md-9 blogSp relatedLi'>
                                  <p className=''>{cont}</p>
                                  <small> <a href={BASE_URL + 'articles-blogs/' + content.slug_term} target='_blank' className="" >Read More</a></small>
                                </div>
                              </div>
                            </React.Fragment>
                            // <li className="relatedLi">
                            //     <span className=''>{cont}</span>
                            //     <small> <a href={'insight-details/' + content.insight_id} target='_blank' className="" >Read More</a></small>
                            // </li>

                          )
                        })}

                      </ul>

                    </div>
                    <div class="artcileslist mobileonly">
                      <InnerArticles />
                    </div>
                  </div>

                  <AdVertical />

                </div>

              </div>

            </div>


          </div>

          <Modal isOpen={showcp} centered size='lg'>

            <ModalBody>
              <h4 class='csph4'>Contact {camp_name}</h4>
              <button
                className='close-btn'
                data-dismiss='modal'
                aria-label='Close'
                onClick={this.handleCloseCp}
              >
                <img src={closebtn} alt='close' />
              </button>
              <div class="formbox csp">
                <form
                  method='post'
                  onSubmit={this.handleSubmit}
                  autoComplete='off'
                  id='loginForm'
                >
                  <div
                    className='form-group has-feedback'
                    style={{ width: '55%', float: 'left' }}
                  >
                    <label className='n7tr' >
                      First Name
                    </label>
                    <input
                      type='text'
                      name='first_name'
                      className='form-control' value={this.state.first_name} required
                    />

                  </div>
                  <div
                    className='form-group has-feedback'
                    style={{ width: '40%', float: 'right' }}
                  >
                    <label className='n7tr' >
                      Last Name
                    </label>
                    <input
                      type='text'
                      name='last_name'
                      className='form-control' value={this.state.last_name} required
                    />

                  </div>
                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Mobile Number
                    </label>
                    <input
                      type='text'
                      name='reg_mobile'
                      className='form-control' required
                    />

                  </div>
                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Email ID
                    </label>
                    <input
                      type='text'
                      name='reg_email'
                      className='form-control' value={this.state.email_id} required
                    />

                  </div>

                  <div className='form-group has-feedback'>
                    <label className='n7tr'>
                      Any Message
                    </label>
                    <textarea

                      name='any_message'
                      value={this.state.any_message}

                      className='form-control' required
                    />
                  </div>

                  <div className='form-group has-feedback'>
                    <input
                      type='submit'
                      name='submit'
                      value='Submit'
                      className='submit btn btn-primary btn-block btn-css'
                    />
                  </div>
                </form>
              </div>
            </ModalBody>

          </Modal>
          <Footer />

          <nav class="floating-menu hidden" id="sideMenuContainer">
            <a href="#about_section" onClick={() => this.handleclickhide()}>About</a>
            <a href="#keyinfo_section" onClick={() => this.handleclickhide()}>Key Information</a>
            <a href="#location_section" onClick={() => this.handleclickhide()}>Location</a>
            <a href="#gallery_section" onClick={() => this.handleclickhide()}>Gallery</a>
            <a href="#review_section" onClick={() => this.handleclickhide()}>Reviews/ Comments</a>
            <a href="#contactinfo_section" onClick={() => this.handleclickhide()}>Contact Info</a>
          </nav>
          <div className="floating-menu-btn" ref={this.wrapperRef} onClick={() => this.handleclick()}><i className="fa fa-bars" aria-hidden="true"></i></div>
        </div>
      </React.Fragment>
    );
  }
}

export default LearningCampsSinglePage;
